import { render, staticRenderFns } from "./SerialView.vue?vue&type=template&id=325281d0&"
import script from "./SerialView.vue?vue&type=script&lang=js&"
export * from "./SerialView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports